import { Box, styled } from '@mui/material';

export const DriverSummaryWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  fontSize: '16px',
  '& div': {
    flexBasis: '40%'
  },
  '& strong': {
    marginRight: theme.spacing(1)
  }
}));
